


import { useContext, useEffect, useState } from "react";
import { NotificationComp } from "./notificationComp";
import { TitleInput } from "./titleInput";
import { fetchAPI, postAPI } from "../api/api";
import { SettingHeader } from "../molecule/SettingHeader";
import { ToastContext } from "../App";
import { SettingsHeader } from "../molecule/settingsHeader";
import { VerticalLayout } from "./layout";

export function NotificationSetting({ }) {
  const toastContext = useContext(ToastContext)
  const [settings, setSettings] = useState([
  {
    "SettingID": 1,
    "Title": "Nieuwe berichten van werknemers",
    "active": false
  },
  {
    "SettingID": 2,
    "Title": "Voortgangsterugblik van werknemers",
    "active": false
  },
  {
    "SettingID": 3,
    "Title": "Nieuwe e-learning module beschikbaar",
    "active": false
  },
  {
    "SettingID": 4,
    "Title": "Herinnering: niet-voltooide e-learning",
    "active": false
  },
  {
    "SettingID": 5,
    "Title": "E-learning certificaat behaald",
    "active": false
  },
  {
    "SettingID": 6,
    "Title": "Deadline voor e-learning nadert",
    "active": false
  },
  {
    "SettingID": 7,
    "Title": "Nieuwe werknemer toegevoegd aan platform",
    "active": false
  },
  {
    "SettingID": 8,
    "Title": "Werknemer heeft profiel gewijzigd",
    "active": false
  },
  {
    "SettingID": 9,
    "Title": "Feedback ontvangen op e-learning",
    "active": false
  },
  {
    "SettingID": 10,
    "Title": "Nieuwe interne training beschikbaar",
    "active": false
  },
  {
    "SettingID": 11,
    "Title": "Herinnering: jaarlijkse evaluatie",
    "active": false
  }
])
  const adjustSetting = async (index) => {
    const newSettings = [...settings]
    newSettings[index].status = !newSettings[index].status
    await updateNotification(newSettings[index])
    if (newSettings[index].status) {
      toastContext.showToast(<>U ontvangt vanaf nu meldingen voor&nbsp;<b>{newSettings[index].notification_name}</b>.</>, "success")
    } else {
      toastContext.showToast(<>U ontvangt vanaf nu &nbsp;<b>geen</b>&nbsp; meldingen meer voor&nbsp;<b>{newSettings[index].notification_name}</b>.</>, "success")
    }
    setSettings(newSettings)
  }

  const updateNotification = async (setting) => {
    const newSetting = {...setting}
    const post = await postAPI('api/users/notifications/update', newSetting)
    if(post == "ok"){
      return 
    }
  }
  const loadNotifications = async () => {
    const url = "api/users/notifications"
    const load = await fetchAPI(url)
    if(load){
      setSettings(load)
    }
  }
  useEffect(() => {
    loadNotifications()
  },[])
  return (
      <VerticalLayout className="settings-card">
      <SettingsHeader
        
        title="Notificaties" 
        description="Selecteer wanneer je een melding wil ontvangen en waarvan" 
        button={false}
      />
      <VerticalLayout className="settings-comp">
      {
        settings.map((setting, index) =>{
          return(
            <NotificationComp
              
              onClick ={() => adjustSetting(index)}
              title={setting.notification_name}
              active={setting.status}
            />
          )
        })
      }
      </VerticalLayout>
</VerticalLayout>



  )
}

